/**
 * Group Service Switch
 * Uses mock data when VITE_ENABLE_MOCK_DATA is true, otherwise real API.
 */
import config from '../config/config';

import * as realService from './groupService';
import * as mockService from './mockGroupService';

const svc = config.features.enableMockData ? mockService : realService;

export const getGroups = svc.getGroups;
export const getGroupById = svc.getGroupById;
export const createGroup = svc.createGroup;
export const updateGroup = svc.updateGroup;
export const deleteGroup = svc.deleteGroup;
export const getGroupEmails = svc.getGroupEmails;
export const addEmailsToGroup = svc.addEmailsToGroup;
export const removeEmailFromGroup = svc.removeEmailFromGroup;
export const getGroupChildGroups = svc.getGroupChildGroups;
export const addChildGroupsToGroup = svc.addChildGroupsToGroup;
export const removeChildGroupFromGroup = svc.removeChildGroupFromGroup;
